<fieldset class="form-group">
  <label *ngIf="label" [for]="'select-input-' + label">{{label | translate}}<span class="text-muted"
      *ngIf="showAsterisk">*</span> </label>
  <a *ngIf="linkLabel.length>0" class="float-end text-primary" type="button"
    (click)="onClickLinkLabel($event)">{{linkLabel | translate}}</a>
  <ng-select appendTo="body" [dropdownPosition]="dropdownPosition" [items]="itemsList" [labelForId]="'select-input-' + label"
    [clearable]="showCloseButton" bindLabel="{{defaultBindLabel}}" disabled="{{disable}}"
    [clearSearchOnAdd]="clearSearchOnAdd" [searchFn]="hasSymbol ? currencySearchFn : null" bindValue="{{bindId}}"
    [compareWith]="compareWithFn" [multiple]="multiple" [closeOnSelect]="!multiple ||  maxSelected==1"
    [maxSelectedItems]="maxSelected" placeholder="{{placeholder}}" [(ngModel)]="selectedItems"
    [notFoundText]="notFoundText" (search)="onSearchInput($event)" (change)="onSelectItem($event)"
    (close)="onCloseMenu($event)">
    <!--for tag like status-->
    <ng-template *ngIf="hasTag && selectedItems" ng-label-tmp let-item="item">
      <div *ngIf="item && item!= '' " class="badge"
        [ngClass]="{'bg-light-success':item == 'PUBLISHED', 'bg-light-warning':item == 'UNPUBLISHED'}">
        {{ item == 'PUBLISHED' ? ('pl_status_published' | translate) : ( item == 'UNPUBLISHED'? ('pl_status_unpublished'
        | translate):'')}}
      </div>
    </ng-template>
    <ng-template *ngIf="hasTag" ng-option-tmp let-item="item" let-index="index">
      <div class="badge" [ngClass]="{'bg-light-success':item == 'PUBLISHED', 'bg-light-warning':item == 'UNPUBLISHED'}">
        {{ item == 'PUBLISHED' ? ('pl_status_published' | translate) :( item != ''? ('pl_status_unpublished' |
        translate):'')}}
      </div>
    </ng-template>

    <!--for icons social media-->
    <ng-template *ngIf="hasIcon" ng-option-tmp ng-label-tmp let-item="item">
      <i [class]="item.icon + ' btn-outline-' + item.label.toLowerCase() + ' me-1'" style="font-size: 1.1rem;"></i>
      {{item.label}}
    </ng-template>
    <!--for country flag-->
    <ng-template *ngIf="hasEmoji" ng-option-tmp ng-label-tmp let-item="item">
      <span>{{item.emoji}}</span> {{item.name}}
    </ng-template>

    <!--for phone code selector-->
    <ng-template *ngIf="hasPhoneCode" ng-label-tmp let-item="item">
      <span class="country-flag me-1">{{item?.emoji}}</span>
      <span class="country-code">+{{item?.phone_code}}</span>
    </ng-template>
    <ng-template *ngIf="hasPhoneCode" ng-option-tmp let-item="item">
      <span class="country-flag">{{item.emoji}}</span>
      <span class="country-code float-end">+{{item.phone_code}}</span>
    </ng-template>

    <!--for currency-->
    <ng-template *ngIf="hasSymbol && selectedItems" ng-label-tmp let-item="item">
      <span class="text-bold-600 pe-2">{{item.symbol}}</span> <span>{{item.label.default_value}}</span> {{item.code}}
    </ng-template>
    <ng-template *ngIf="hasSymbol" ng-option-tmp ng-label-tmp let-item="item">
      <span>{{item.label.default_value}}</span> {{item.code}} <span
        class="text-bold-600 float-end">{{item.symbol}}</span>
    </ng-template>

    <!--for menu-->
    <ng-template *ngIf="hasMenu" ng-option-tmp let-item="item">
      <div class="menu-option d-flex flex-wrap align-items-center gap-2">
        <label class="menu-label text-bold-500 font-small-4 mb-0">{{item.title}}:</label>
        <div class="menu-nav-items d-flex flex-wrap gap-1">
          <span *ngFor="let navLink of item.navigations" class="badge bg-light-grey font-small-1 px-2 py-1 border">
            {{navLink.label}}
          </span>
        </div>
      </div>
    </ng-template>
    <!-- for product and category select-->
    <ng-template *ngIf="hasFilter && selectedItems" ng-option-tmp let-item="item">
      <div class="row">
        <img src="{{item.icon?item.icon.url:item.multimedia[0].url}}" class="rounded-circle ms-3" alt="img-placeholder"
          height="50" width="50">
        <div class="col-auto me-auto my-1">
          <h6 class="mb-0">{{item.title?item.title:item.default_label}}</h6>
          <span *ngIf="item.stock" class="font-small-2">
            Unit in Stock:
          </span>
          <span *ngIf="item.stock" class="font-small-2 text-bold-500">
            {{ item.stock}}
          </span>
          <span *ngIf="item.price" class="font-small-2 ms-2">
            price:
          </span>
          <span *ngIf="item.price" class="font-small-2 text-bold-500 ms-1">
            {{ item.price.sale_price.amount + " " + item.price.sale_price.currency}}
          </span>
        </div>
        <div class="col-auto">
          <span class="badge"
            [ngClass]="{'bg-light-success':item.status == 'PUBLISHED', 'bg-light-warning':item.status == 'UNPUBLISHED'}">
            {{ item.status == 'PUBLISHED' ? ('pl_status_published' | translate) : (item.status == 'UNPUBLISHED'?
            ('pl_status_unpublished' | translate): item.status) }}
          </span>
        </div>
      </div>
    </ng-template>
    <!--thumbnail (icono redondo + placeholder) + título: OPCIÓN del desplegable-->
    <ng-template *ngIf="hasThumb" ng-option-tmp let-item="item">
      <span class="ds-thumb-item ds-thumb-item--option">
        <img *ngIf="getThumbUrl(item) as thumbUrl; else dsThumbOptPlaceholder" class="ds-thumb-img" [src]="thumbUrl"
          [alt]="item[defaultBindLabel]" loading="lazy" (error)="onThumbError(item)" />
        <ng-template #dsThumbOptPlaceholder>
          <span class="ds-thumb-placeholder"><i class="bi bi-image-alt"></i></span>
        </ng-template>
        <span class="ds-thumb-label">{{ item[defaultBindLabel] }}</span>
      </span>
    </ng-template>
    <!-- Single selection is a plain thumbnail + label; multiple selections use removable chips. -->
    <ng-template *ngIf="hasThumb" ng-label-tmp let-item="item" let-clear="clear">
      <span class="ds-thumb-item" [class.ds-thumb-item--chip]="multiple" [class.ds-thumb-item--selection]="!multiple">
        <img *ngIf="getThumbUrl(item) as thumbUrl; else dsThumbLblPlaceholder" class="ds-thumb-img" [src]="thumbUrl"
          [alt]="item[defaultBindLabel]" loading="lazy" (error)="onThumbError(item)" />
        <ng-template #dsThumbLblPlaceholder>
          <span class="ds-thumb-placeholder"><i class="bi bi-image-alt"></i></span>
        </ng-template>
        <span class="ds-thumb-label">{{ item[defaultBindLabel] }}</span>
        <button *ngIf="multiple" type="button" class="ds-thumb-x" (click)="clear(item)" tabindex="-1"
          [attr.aria-label]="'ac_delete' | translate">
          <i class="bi bi-x-lg"></i>
        </button>
      </span>
    </ng-template>
    <ng-template *ngIf="!multiple && !hasSymbol && !hasEmoji && !hasIcon && !hasTag && !hasThumb" ng-option-tmp
      ng-label-tmp let-item="item">
      {{item[defaultBindLabel]|translate}}
    </ng-template>
  </ng-select>
</fieldset>
